import React, { useRef, useState } from 'react';
import Modal from '../../components/Modal';
import PanelCustomization from '../../panel/PanelCustomization';
import jsPDF from 'jspdf';
import { logEvent } from '../../util/apiUtils';

/**
 * Displays a Modal showing saved test selections, including CPT Codes and quantity, and a button
 * that will save a PDF of the modal body.
 */
const SaveCptCodeModal = ({ gearOrderId, gearRequisition, omsRequisition, onClose }) => {
	const [cptSaveInProgress, setCptSaveInProgress] = useState(false);
	const panelCustomizationRef = useRef();

	if (!omsRequisition || !gearRequisition) {
		onClose();
		return null;
	}

	const handleOrderableItemPrintRef = () => {
		setCptSaveInProgress(true);
		const pdf = new jsPDF('portrait', 'pt', 'letter');
		const data = panelCustomizationRef.current;

		// Scale the output down when the HTML content is wider than the PDF page size
		// '+ 110' is left + right margin plus an additional 40 for good measure
		const htmlComponentWidth = data.getBoundingClientRect().width + 110;
		const pdfPageWidth = pdf.getPageWidth();
		const scale = Math.min(1, pdfPageWidth / htmlComponentWidth);

		pdf.html(data, {
			// margin: 9,
			margin: [10, 20, 10, 50],
			html2canvas: {
				scale: scale
			}
		})
			.then(() => {
				pdf.save('test-selection.pdf');
			})
			.finally(() => setCptSaveInProgress(false));
		
		logEvent(
			'{} - "Export CPT Codes" clicked. gearOrderId={}, gearReqId={}, omsRequisitionId={}',
			'UI_ACTION_EXPORT_CPT_CODES',
			gearOrderId, gearRequisition.id, omsRequisition?.id
		);
	};

	const isCssCollectionPack = omsRequisition?.orderableItem?.collectionPackSupplier === "CSS";

	return (
		<Modal
			id={gearRequisition.omsOrderableItemId + '-customization-modal'}
			title={'Test Selections'}
			cancelAction={!cptSaveInProgress ? 'OK' : null} // Hide the footer when save is in progress
			handleCancel={onClose}
			modalHidden={onClose}
			modalXL={isCssCollectionPack}
			displayProps={{ modalContent: { className: 'modal-content modal-scroll' } }}
		>
			{omsRequisition && (
				<>
					{cptSaveInProgress && (
						<div className="loading-shield" style={{ position: 'absolute', zIndex: '90' }}>
							<i
								className="fa fa-spinner fa-spin fa-fw loading-icon"
								style={{ width: '1em', position: 'absolute' }}
							></i>
						</div>
					)}
					<button
						type="button"
						className="btn-link btn-unstyled pull-right"
						onClick={() => {
							handleOrderableItemPrintRef();
						}}
						title="Save Test Selections"
					>
						<i className="fa fa-print padding-x-xs"></i>
					</button>
					<div
						// "pointer-events: none" so the user cannot check/uncheck test selections
						style={{ pointerEvents: 'none' }}
						ref={panelCustomizationRef}
						className={cptSaveInProgress ? 'profile-list-print' : null}
					>
						<PanelCustomization
							gearRequisition={gearRequisition}
							omsRequisition={omsRequisition}
							onSelection={isCssCollectionPack ? null : () => {}} // Create an empty onSelection method so checkboxes are displayed
							displayPatientInstructions={false}
							orderType={(gearRequisition?.dropShip && !gearRequisition.reqNumber) ? 'dropShip' : gearRequisition?.shipToOffice ? 'bulk' : 'registration'}
							splitCptQty={true}
						></PanelCustomization>
					</div>
				</>
			)}
		</Modal>
	);
};

export default SaveCptCodeModal;
